import { Box, Button, Flex, Text } from "@chakra-ui/react";
import Card from "shared/components/horizon-ui/card/Card";
import InfiniteTable from "shared/components/table/InfiniteTable";
import { LayoutsE, ModuleE, PathsE, PathsParams } from "shared/routes";
import { useGetColumns, useGetGetBreadcrumbs } from "./constants";
import { useParams } from "react-router-dom";
import { useGetOneService } from "shared/api/requests/services";
import PageTitle from "shared/views/admin/PageTitle";
import { TableNameE } from "shared/api/types/common";
import { useBlackListService } from "../../../api/requests/blackList";
import { BlackListT } from "../../../api/types/blacklist";
import Link from "../../../components/Link";
import MuiIcon from "../../../../components/MuiIcon";

const Index = () => {
  const { serviceId } = useParams<PathsParams[PathsE.BLACKLIST]>();

  // const { page, size } = useStateFromQueryParams().getSearchParams<SearchParams[PathsE.UPDATE_SETTING]>();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined,
  });

  const { useGetBlackList, useDeleteBlackListItem } = useBlackListService({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.BLACKLIST,
  });
  const { mutate } = useDeleteBlackListItem({
    pathParams: { serviceId },
    params: undefined,
  });

  const handleDeleteRow = async (telegramId: number) => {
    mutate({ telegram_id: telegramId });
  };

  const columns = useGetColumns({ handleDeleteRow });
  const breadcrumbs = useGetGetBreadcrumbs();

  if (!currentService) return null;

  // TODO: It should be translate
  return (
    <Box>
      <Flex alignItems="center" gap="20px">
        <PageTitle title={"Black List"} breadcrumbs={breadcrumbs} />
        <Link
          layout={LayoutsE.DASHBOARD}
          path={PathsE.CREATE_BLACKLIST_ITEM}
          pathsParams={{ serviceId }}
        >
          <Button
            color="white"
            backgroundColor="brand.500"
            _hover={{ backgroundColor: "brand.400" }}
          >
            <MuiIcon name="add" size={24} color="gray800" variant="rounded" />
            <Text ml="8px">Black List Item</Text>
          </Button>
        </Link>
      </Flex>

      <Card mb="20px" borderRadius="20px" px="30px">
        <InfiniteTable<BlackListT>
          query={useGetBlackList as FixMeLater}
          columns={columns}
          filterFields={[]}
          tableName={TableNameE.BLACKLIST}
        />
      </Card>
    </Box>
  );
};

export default Index;
